/* Thông báo: biểu tượng theo loại, cách đọc "x phút trước". Port từ app cũ. */

export const NT_IC: Record<string, string> = { event: '📅', assign: '📌', watch: '👀', status: '🔄', review: '📝', done: '✅', back: '↩️', cancel: '⛔', comment: '💬', update: '✏️', due: '⏰', overdue: '⚠️', reassign: '↪️' };

/** "vừa xong" / "x phút trước" / "x giờ trước" / "x ngày trước" (đến 7 ngày), sau đó là ngày tháng. */
export function agoText(iso: string, nowMs: number = Date.now()): string {
  const m = Math.round((nowMs - +new Date(iso)) / 6e4);
  if (m < 1) return 'vừa xong';
  if (m < 60) return m + ' phút trước';
  const h = Math.round(m / 60);
  if (h < 24) return h + ' giờ trước';
  const d = Math.round(h / 24);
  return d < 8 ? d + ' ngày trước' : new Date(iso).toLocaleDateString('vi-VN');
}

/** Mã thông báo nhắc hạn việc / nhắc lịch trong ngày: cố định theo (việc, ngày, người) nên mỗi người chỉ nhận một lần/ngày. */
export const reminderId = (prefix: 'due' | 'ev', refId: string, day: string, userId: string): string => `${prefix}_${refId}_${day}_${userId}`.replace(/[^A-Za-z0-9_-]/g, '');
